import styled from 'styled-components';

const Container = styled.div`
  width: 95%;
  margin: 20px auto;
`;

export const DashboardContainer = styled.div`
  width: 95%;
  margin: 20px auto;
  margin-top: 120px;
`;

export default Container;
